var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarKeyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 6.8c0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2V4.4c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v2.4zM24.4 6.8c0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2V4.4c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v2.4zM10 6.8C10 7.46 9.46 8 8.8 8c-.66 0-1.2-.54-1.2-1.2V4.4c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v2.4zM20.2 13.6L17 10.4l3.2 3.2z",
    stroke: "#00234B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 10.4l-3.198 3.2 3.199-3.2zM25.4 13.6l-3.2-3.2 3.2 3.2z",
    stroke: "#00234B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 10.4l-3.199 3.2 3.2-3.2zM15 13.6l-3.2-3.2 3.2 3.2z",
    stroke: "#00234B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.4l-3.199 3.2 3.2-3.2zM9.8 13.6l-3.2-3.2 3.2 3.2z",
    stroke: "#00234B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 10.4l-3.2 3.2 3.2-3.2zM9.8 18.8l-3.2-3.198L9.8 18.8zM9.8 15.6l-3.2 3.2 3.2-3.2zM15 18.8l-3.2-3.198L15 18.8zM15 15.6l-3.199 3.2 3.2-3.2zM20.2 15.6H17v3.2h3.2v-3.2zM25.4 15.6h-3.2v3.2h3.2v-3.2zM24 24.8l-1.6-1.599h-8.134a4 4 0 100 3.2H22.4l1.6-1.6z",
    stroke: "#00234B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 5.6h-2v1.2c0 .66-.54 1.2-1.2 1.2-.66 0-1.2-.54-1.2-1.2V5.6h-4.8v1.2c0 .66-.54 1.2-1.2 1.2-.659 0-1.2-.54-1.2-1.2V5.6H10v1.2C10 7.46 9.46 8 8.8 8c-.66 0-1.2-.54-1.2-1.2V5.6h-2A2.4 2.4 0 003.2 8v16a2.4 2.4 0 002.4 2.4h1.335a4 4 0 117.33-3.2H22.4l1.6 1.6-1.6 1.6h4a2.4 2.4 0 002.4-2.4V8a2.4 2.4 0 00-2.4-2.4z",
    stroke: "#00234B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 25.802a1 1 0 002 0V23.8a1 1 0 00-2 0v2.002h0z",
    stroke: "#00234B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarKeyIcon);
export default __webpack_public_path__ + "static/media/calendar-key-icon.2d7e1e04e4f6e6d9690fec58c3329d8c.svg";
export { ForwardRef as ReactComponent };